import PropTypes from 'prop-types';
import { cloneElement, useContext } from 'react';
import TooltipContext from './TooltipContext';

const TooltipTrigger = ({ children, disabled }) => {
  const { triggerRef, show } = useContext(TooltipContext);

  const handleMouseEnter = e => {
    if (!disabled) {
      show();
      e.preventDefault();
    }
  };

  const register = () => ({
    ref: triggerRef,
    onMouseEnter: handleMouseEnter,
  });

  if (!children) return null;

  return typeof children === 'function'
    ? children({ register })
    : cloneElement(children, { ...register() });
};

TooltipTrigger.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  disabled: PropTypes.bool,
};

TooltipTrigger.defaultProps = {
  children: null,
  disabled: false,
};

export default TooltipTrigger;
